import { LANDING } from "@/constants/testIds";
import { t } from "@/lib/i18n";

// Full-width Register widget — the entire media acts as a click target.
export default function RegisterWidget({ registerRef, registerMediaUrl, onRegister, lang }) {
  return (
    <section className="ddf-section" ref={registerRef}>
      <button
        type="button"
        className="ddf-register-widget"
        data-testid={LANDING.registerWidget}
        onClick={() => onRegister("register_widget")}
        aria-label={t(lang, "register_cta")}
      >
        {registerMediaUrl ? (
          <img
            src={registerMediaUrl}
            alt={t(lang, "register_with_us")}
            data-testid={LANDING.registerOverlayBtn}
          />
        ) : (
          <div className="ddf-register-empty" data-testid={LANDING.registerOverlayBtn}>
            <h3>{t(lang, "register_with_us")}</h3>
            <p>{t(lang, "register_subtitle")}</p>
          </div>
        )}
      </button>
    </section>
  );
}
